<template>
  <div class="ba-w-100 ba-grid ba-gp-08">
    <template v-if="!loading" class="ba-grid a-gp-08">
      <template v-if="campaigns.length > 0">
        <div class="ba-grid ba-w-100 ba-gp-08">
          <span for="campaign" class="ba-custom-label">{{ $t('ct-social-proof-campaign') }}</span>
          <select name="campaign" id="campaign" class="ba-select" v-model="socialproof_campaign.id">
            <option value="0" disabled selected>{{ $t('ct-social-proof-select') }}</option>
            <option v-if="campaigns" v-for="(campaign, index) in campaigns" :value="campaign.id" :key="index">
              {{ campaign.name }}
            </option>
          </select>
        </div>
        <hr class="ba-hr-row">
        <div class="ba-grid" v-if="website && website.layouts && website.layouts[0]">
          <span class="ba-custom-label">{{ $t('ct-pages') }}</span>
          <div class="ba-w-100 ba-flex ba-gp-08 ba-f-wrap">
            <div v-for="(page, index) in website.layouts[0].pages" :key="index">
              <div class="ba-form-check">
                <input type="checkbox" :value="page.id" :id="`page-${page.id}`"
                  v-model="socialproof_campaign.pages">
                <label :for="`page-${page.id}`">{{ page.name }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="ba-w-100 ba-flex ba-ai-center ba-gp-08 ba-jc-fe">
          <a href="https://office.builderall.com/br/office/new-social-proof" target="_blank"
            class="ba-btn ba-md ba-blue"><builderall-icon code='4970'></builderall-icon>{{ $t('ct-goto-social-proof') }}</a>
          <button class="ba-btn ba-md ba-blue" @click="save">{{ $t('ct-save') }}</button>
        </div>
      </template>
      <template v-else>
        <div class="ba-grid ba-gp-08">
          <span>{{ $t('ct-social-proof-empty-campaign') }}</span>
          <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fs">
            <a href="https://office.builderall.com/br/office/new-social-proof" target="_blank"
            class="ba-btn ba-md ba-blue"><builderall-icon code='4970'></builderall-icon>{{ $t('ct-goto-social-proof') }}</a>
          </div>
        </div>
      </template>
    </template>
    <div class="text-center" v-else>
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
import { getAllCampaigns } from '../../../../js/services/integrations-internas/socialProof';
import { getWebsiteConfig, setWebsiteConfig } from '../../../../js/services/editor/configManager';
import { get as getWebsite } from '../../../../js/services/editor/website';

export default {
  name: 'SocialProof',

  props: ['website_id'],

  components: {
    SweetModal
  },

  data() {
    return {
      loading: false,
      website: {
        layouts: [{ pages: [] }]
      },
      website_configs: [],
      campaigns: [],
      socialproof_campaign: {
        id: 0,
        pages: [],
        campaign: {}
      },
      officeDomain: ''
    };
  },
  async mounted() {
    await this.getAllCampaigns();
    await this.getWebsite();
    await this.getWebsiteConfigs();
  },

  created () {
    this.officeDomain = typeof process.env.OFFICE_URL !== 'undefined' ? process.env.OFFICE_URL : 'https://office.builderall.com';
  },

  methods: {
    async open() {
      // this.$refs['social-proof'].open();

      this.$loading.show();
      this.loading = true;

      this.getAllCampaigns();
      await this.getWebsite();
      await this.getWebsiteConfigs();

      this.$loading.hide();
    },


    async getWebsite() {
      getWebsite(this.$route.params.id || this.$route.params.website_id)
        .then(data => {
          this.website = data.data;
        })
        .catch(error => {
          console.warn(error);
        });
    },

    async getWebsiteConfigs() {
      await getWebsiteConfig(this.$route.params.id || this.$route.params.website_id)
        .then(({ data }) => {
          this.website_configs = data;

          if (Object.keys(data).includes('socialProofSettings'))
            this.socialproof_campaign = JSON.parse(this.website_configs['socialProofSettings'].value);

        })
        .catch(error => {
          console.error('error', error);
        });
    },

    async getAllCampaigns() {
      this.loading = true;
      await getAllCampaigns()
        .then(res => {
          if (!res.data.error) {
            if (res.data.data)
              this.campaigns = res.data.data.data;
            this.loading = false;

          }
        })
        .catch(error => {
          console.error('error', error);
          this.loading = false;

        });

    },

    save() {
      let campaign = this.campaigns.find(campaign => campaign.id === this.socialproof_campaign.id);

      if (campaign) {
        let data = {
          website_id: this.$route.params.id || this.$route.params.website_id,
          key: 'socialProofSettings',
          value: JSON.stringify({
            'id': this.socialproof_campaign.id,
            'pages': this.socialproof_campaign.pages,
            'campaign': this.campaigns.find(campaign => campaign.id === this.socialproof_campaign.id),
          })
        };

        this.$loading.show();

        setWebsiteConfig(data)
          .then(({ data }) => {
            this.$snotify.success(this.$t('ct-saved-successfully'));
          })
          .catch(err => console.warn(err))
          .finally(() => this.$loading.hide());
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/dashboard/layout/site/SocialProof.vue